import {createEntityAdapter, EntityAdapter, EntityState} from "@ngrx/entity";
import {ProductFaceDefaultMeasurements as Entity} from "./product-face-default-measurements.model";
import {IPageInfo, IResultWithPageInfo, ITableSort} from "../app-store.interfaces";


export interface ProductFaceDefaultMeasurementsState extends EntityState<Entity> {
  entities: { [id: number]: Entity };
  ids: number[];
  isLoading: boolean;
  error: Error | undefined;
  currentPage: IPageInfo;
  currentSort: ITableSort | undefined;
  currentEntityId: number | undefined,
  history: { correlationId: string, payload: Entity | Entity[] | number | number[] | IResultWithPageInfo<Entity> }[];
}

export const productFaceDefaultMeasurementsEntityAdapter: EntityAdapter<Entity> = createEntityAdapter<Entity>(
  {
    selectId: (defaultMeasurements: Entity) => defaultMeasurements.id
  }
);

export const initialState: ProductFaceDefaultMeasurementsState = productFaceDefaultMeasurementsEntityAdapter.getInitialState({
  entities: [],
  ids: [],
  isLoading: false,
  error: undefined,
  currentPage: { page: { pageNumber: 0, pageSize: 25 }, totalCount: 0},
  currentSort: undefined,
  currentEntityId: undefined,
  history: []
});
